var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('dashboard-core-app-bar'),_c('dashboard-core-drawer'),_c('dashboard-core-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }